<form *ngIf="form" id="addAddressForm" [formGroup]="form" novalidate>
    <div class="flex flexWrap--wrap flexJustify--between flexAlign--center vert-0100">

        <mat-form-field class="col__ col__xs--50e" [hideRequiredMarker]="true">
            <mat-label>Latitude</mat-label>
            <input matInput type="text" placeholder="Latitude" data-test-id="latitudeInput" formControlName="latitude" autocomplete="off"
            />
            <app-input-error [formControlItem]="form.controls.latitude"></app-input-error>
        </mat-form-field>

        <mat-form-field class="col__ col__xs--50e" [hideRequiredMarker]="true">
            <mat-label>Longitude</mat-label>
            <input matInput type="text" placeholder="Longitude" data-test-id="longitudeInput" formControlName="longitude" autocomplete="off"
            />
            <app-input-error [formControlItem]="form.controls.longitude"></app-input-error>
        </mat-form-field>
    </div>

    <div class="flex flexWrap--wrap flexJustify--between flexAlign--center">
        <div class="col__ col__xs--50e">
            <mat-checkbox formControlName="geocodeBad" disableRipple data-test-id="addressVerifiedCheckbox">Geocode Incorrect</mat-checkbox>
        </div>
        <div class="col__ col__xs--50e align--right">
            <button type="button" class="link link--noline link--small" (click)="onUseMyLocationClick()"><i class="fal fa-location"></i> Use my location</button>
        </div>
    </div>

    <div class="flex flexWrap--wrap flexJustify--between flexAlign--start vert-0100">
        <div class="col__">
            <button type="button" class="btn" (click)="onSaveClick()">Save</button>
        </div>
    </div>
</form>